import React, { useState, useEffect, useContext, useCallback, Fragment } from 'react';
import Layout from 'components/sales/layout/layout';
import { BaseUrl } from 'contexts/baseUrl/baseUrl';
import 'react-toastify/dist/ReactToastify.css';
import { Link } from 'react-router-dom';
import ModalPop from 'components/sales/modal/modal';
import { Button } from "react-bootstrap";
import localization from 'assets/localization/localization';
import DropDownInput from 'components/sales/Input/dropDownInput/dropDownInput';
import ConstantInput from 'components/sales/Input/constantInput/constantInput';
import Regex from 'services/utils/regex/Regex';
import Images from 'assets/images/imageData';
import { toast, ToastContainer } from "react-toastify";

const EditQuotation = ({
    match,
    quotation,
    getQuotation,
    getMaterialPrice,
    getSolution,
    solution,
    setQuotation
}) => {
    const { baseUrl } = useContext(BaseUrl);
    const [isModal, setIsModal] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [catId, setCatId] = useState(null);
    const [solutionType, setSolutionType] = useState('');
    const [materialId, setMaterialId] = useState(null);
    const [material, setMaterial] = useState([]);
    const [index, setIndex] = useState(0);
    const [price, setPrice] = useState(0);
    const [data, setData] = useState({ id: match.params.id, lead_id: '', solution_type_id: '', amc_cost: '', server_charge: '', materials: [{ category: '', category_name: '', material: '', material_name: '', cost:0, quantity: '', unit_price: '' }] });

    useEffect(() => {
        (async () => {
            setIsLoading(true)
            await getQuotation(match.params.id)
            setIsLoading(false)
        })()
    }, [])
    useEffect(() => {
        (async () => {
            setIsLoading(true)
            await getSolution()
            setIsLoading(false)
        })()
    }, [])
    useEffect(() => {
        if (catId != null) {
            (async () => {
                setIsLoading(true)
                setMaterial(await getSolution(catId))
                setIsLoading(false)
            })()
        }
    }, [catId])
    useEffect(() => {
        if (materialId != null) {
            (async () => {
                setIsLoading(true)
                setPrice(await getMaterialPrice(materialId))
                setIsLoading(false)
            })()
        }
    }, [materialId])
    useEffect(() => {
        if (price[0]?.sale_value != null) {
            const newData = { ...data };
            newData.materials[index].cost = price[0]?.sale_value;
            setData(newData);
        }
    }, [price])
    useEffect(() => {
        setData({ ...data, lead_id: quotation?.quotation?.[0]?.lead_id, solution_type_id: quotation?.quotation?.[0]?.solution_type_id, amc_cost: quotation?.quotation?.[0]?.amc_cost, server_charge: quotation?.quotation?.[0]?.server_charge, materials: quotation?.quotation_material })

        if (quotation?.quotation?.[0]?.status == "L1 Rejected" || quotation?.quotation?.[0]?.status == "Client Rejected" || quotation?.quotation?.[0]?.status == "L2 Rejected") {
            setData((data) => { return ({ ...data, id: 0 }) })
        }
    }, [quotation])

    const headerBtns = () => {
        return (
            <Fragment>
                <Button
                    onClick={() => {
                        if (data?.solution_type_id == '' || data?.amc_cost == '' || data?.server_charge == '' || data?.solution_type_id == null || data?.amc_cost == null || data?.server_charge == null) {
                            toast.error('Fill all fields in the quotation block');
                            return
                        }
                        for (let elem in data.materials) {
                            if (data?.materials?.[elem]?.category == '' || data?.materials?.[elem]?.category == null) {
                                toast.error('Select Catgeory');
                                return false;
                            }
                            if (data?.materials?.[elem]?.material == '' || data?.materials?.[elem]?.material == null) {
                                toast.error('Select Material for Category');
                                return false;
                            }
                            if (data?.materials?.[elem]?.quantity == '' || data?.materials?.[elem]?.quantity == null || data?.materials?.[elem]?.unit_price == '' || data?.materials?.[elem]?.unit_price == null) {
                                toast.error('Fill Quantity and Unit Price');
                                return false;
                            }
                        }
                        (async () => {
                            setIsLoading(true)
                            await setQuotation(data)
                            setIsLoading(false)
                        })()
                        setIsModal(true)
                    }}
                    className="filter-hamburger btn btn-transparent"
                >
                    {quotation?.quotation?.[0]?.status_id == 1 ? 'Save' : 'Submit'}
                </Button>
            </Fragment>
        );
    }
    const handleDelete = (index) => {
        if (data?.materials.length > 1) {
            let form = [...data?.materials]
            form.splice(index, 1)
            setData({ ...data, materials: form })
        }

    }
    const handleAdd = () => {
        const form = [...data?.materials]
        form.push({ category: '', material: '', quantity: '', unit_price: '' })
        setData({ ...data, materials: form })
    }
    return (
        <Layout
            title="Quotation Submitted"
            Buttons={(quotation?.quotation?.[0]?.status == "L1 Pending" || quotation?.quotation?.[0]?.status == "L1 Rejected" || quotation?.quotation?.[0]?.status == "Client Rejected" || quotation?.quotation?.[0]?.status == "L2 Rejected") && headerBtns}
            isLoading={isLoading}
            isGoback
        >
            <div className="panel-card card-details" width="100%">
                <div className="panel-heading">{localization.quotation}</div>
                <div className="panel-body">
                    <div className="details-listing detail_alignment">
                        <div className='row'>
                            <div className='col-md-12'>
                                <DropDownInput
                                    data={solution?.solutionType}
                                    value={quotation?.quotation?.[0]?.solution_type}
                                    label="Solution Type"
                                    required
                                    errorMsg={localization.requiredName}
                                    getIdValue={(val) => {
                                        setSolutionType(val.value)
                                        setData({ ...data, solution_type_id: val.id })
                                    }}
                                    isStarRequired={true}
                                />
                            </div>
                        </div>
                        <div className='row'>
                            <div className='col-md-6'>
                                <ConstantInput
                                    label='AMC Cost'
                                    regex={Regex.numeric.test(data?.amc_cost)}
                                    value={data?.amc_cost}
                                    type="number"
                                    handleChange={(value) => {
                                        setData({ ...data, amc_cost: value });
                                    }}
                                    isStarRequired={true}
                                />
                            </div>
                            <div className='col-md-6'>
                                <ConstantInput
                                    label='Server Charge'
                                    regex={Regex.numeric.test(data?.server_charge)}
                                    value={data?.server_charge}
                                    type="number"
                                    handleChange={(value) => {
                                        setData({ ...data, server_charge: value });
                                    }}
                                    isStarRequired={true}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="panel-card card-details" width="100%">
                <div className="panel-heading">{localization.material}</div>
                <div className="panel-body">

                    {data?.materials?.map((elem, index) => {
                        return (
                            <div className="details-listing detail_alignment" key={index}>
                                <div className='row'>
                                    <div className='col-md-6'>
                                        <DropDownInput
                                            data={solution?.category}
                                            value={quotation?.quotation_material?.[index]?.category_name}
                                            label="Select Category"
                                            required
                                            errorMsg={localization.requiredName}
                                            getIdValue={(val) => {
                                                const newData = { ...data };
                                                newData.materials[index].category = val.id;
                                                setData(newData);
                                                setCatId(val.id);
                                            }}
                                            isStarRequired={true}
                                        />
                                    </div>
                                    {elem?.category != '' &&
                                        <div className='col-md-6'>
                                            <DropDownInput
                                                data={material}
                                                value={quotation?.quotation_material?.[index]?.material_name}
                                                label="Select Material"
                                                required
                                                errorMsg={localization.requiredName}
                                                getIdValue={(val) => {
                                                    const newData = { ...data };
                                                    newData.materials[index].material = val.id;
                                                    setData(newData);
                                                    setMaterialId(val.id)
                                                    setIndex(index);
                                                }}
                                                isStarRequired={true}
                                            />
                                        </div>
                                    }
                                </div>

                                <div className='row'>
                                    <div className='col-md-3'>
                                        <ConstantInput
                                            label='Cost Value'
                                            disabled={true}
                                            value={data?.materials[index]?.cost}
                                            type="text"
                                        />
                                    </div>
                                    <div className='col-md-3'>
                                        <ConstantInput
                                            label='Quantity'
                                            regex={Regex.numeric.test(elem?.quantity)}
                                            value={data?.materials[index]?.quantity}
                                            type="number"
                                            handleChange={(value) => {
                                                const newData = { ...data };
                                                newData.materials[index].quantity = value;
                                                setData(newData);
                                            }}
                                        />
                                    </div>
                                    <div className='col-md-3'>
                                        <ConstantInput
                                            label='Sales Unit'
                                            regex={Regex.numeric.test(elem?.unit_price)}
                                            value={data?.materials[index]?.unit_price}
                                            type="number"
                                            handleChange={(value) => {
                                                const newData = { ...data };
                                                newData.materials[index].unit_price = value;
                                                setData(newData);
                                            }}
                                        />
                                    </div>
                                    <div className='col-md-3'>
                                        <ConstantInput
                                            label='Total'
                                            disabled={true}
                                            value={data?.materials?.[index]?.quantity * data?.materials?.[index]?.unit_price}
                                            type="text"
                                        />
                                    </div>
                                </div>
                                <div className='row mb-4'>
                                    <button className='btn btn-primary ml-3' onClick={() => handleAdd()}> Add More</button>
                                    <button className='btn btn-danger ml-4' onClick={() => handleDelete(index)} src="https://static.vecteezy.com/system/resources/previews/009/267/401/original/minus-sign-icon-free-png.png">Remove</button>
                                </div>
                                {index != data?.materials.length - 1 && <hr />}


                            </div>
                        )
                    })}

                </div>
            </div>

            <ModalPop
                title=""
                show={isModal}
                handleModalHide={() => setIsModal(false)}
            >
                <div className="text-center">
                    <div className="success">
                        <img src={Images?.tick} alt="" />
                    </div>
                    <h5>Quotation Submitted Successfully</h5>
                    <Link to={`${baseUrl}/project-onboarding/view-quotation/${match.params.id}`} className="btn btn-primary mb-4">View Quotation</Link>
                </div>
            </ModalPop>
        </Layout>

    );
};

export default EditQuotation;
